import { useQuery } from '@tanstack/react-query';

import { getTagCategories } from '@arrived/api_v2';
import { TagCategory } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions, UseQueryResult } from '../queries.utils';
import { tagCategoriesQueryKey } from './tags.keys';

export function useGetTagCategoriesQuery(options?: UseQueryOptions<TagCategory[]>): UseQueryResult<TagCategory[]> {
  return useQuery(tagCategoriesQueryKey, async () => getTagCategories(), {
    ...options,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
    enabled: options?.enabled ?? true,
  });
}
